// PercentSlider.tsx
import React, { useState } from "react";
import "./styles/PercentSlider.scss";

interface PercentSliderProps {
  id: string;
  text: string;
  emoji: string;
  statement: string;
  value: number | null;
  onChange: (value: number | null) => void;
}

const PercentSlider: React.FC<PercentSliderProps> = ({
  id,
  text,
  emoji,
  statement,
  value,
  onChange,
}) => {
  const [localValue, setLocalValue] = useState(0);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value);
    setLocalValue(newValue);
    onChange(newValue);
  };

  const handleClear = () => {
    setLocalValue(0);
    onChange(null);
  };

  const displayValue = value ?? localValue;
  const isSet = value != null;

  const formattedStatement = isSet
    ? statement.replace("<answer>", `${value}%`)
    : null;

  return (
    <div className="percent-slider">
      <div className="percent-slider__header">
        {/* <span className="percent-slider__emoji">{emoji}</span> */}
        <div className="percent-slider__question">{text}</div>
      </div>

      <div className="percent-slider__container">
        {isSet && (
          <div
            className={`percent-slider__bubble ${
              !isSet ? "percent-slider__bubble--unset" : ""
            }`}
            style={{ left: `${displayValue}%` }}
          >
            {isSet ? `${value}%` : "Not set"}
          </div>
        )}

        <div className="percent-slider__track">
          {displayValue && (
            <div
              className="percent-slider__fill"
              style={{ width: `${isSet ? displayValue : 0}%` }}
            />
          )}

          <div
            className={`percent-slider__thumb ${
              !isSet ? "percent-slider__thumb--unset" : ""
            }`}
            style={{ left: `${displayValue}%` }}
          />
          <input
            type="range"
            className="percent-slider__input"
            id={id}
            min="0"
            max="100"
            value={displayValue}
            onChange={handleInput}
          />
        </div>

        <div className="percent-slider__labels">
          <span>0%</span>
          <span>50%</span>
          <span>100%</span>
        </div>
      </div>
      {isSet && (
        <button
          className="percent-slider__clear"
          onClick={handleClear}
          disabled={!isSet}
        >
          Clear selection
        </button>
      )}
    </div>
  );
};

export default PercentSlider;
